export const useRaytingDimensions = (width: number) => {
    const circleSize = width * 0.2362;
    const overlap = circleSize * 0.1915;
    const startX = (width - (circleSize * 5 - overlap * 4)) / 2; // Center the row of circles
  
    return { circleSize, overlap, startX };
  };
  
  